export const ROOT_TRANSFER_ACC = 'RootTransfer'
export const GLONASS_SOFT_ADMINS = new Set([ROOT_TRANSFER_ACC, 'etalon1'])
